import { get } from 'lodash';

export const getIsDashboardsMenuOpened = state => JSON.parse(get(state, 'dashboardsMenu.isDashboardsMenuOpened'));
export const getDashboardsCurrentTab = state => get(state, 'dashboardsMenu.dashboardsCurrentTab');
